import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, Teleport as _Teleport, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "shadow-sm sm:overflow-hidden sm:rounded-md" }
const _hoisted_2 = { class: "space-y-6 bg-white px-4 py-6 sm:p-6" }
const _hoisted_3 = { class: "text-base font-semibold text-gray-900" }
const _hoisted_4 = { class: "mt-1 text-sm text-gray-500" }
const _hoisted_5 = {
  key: 0,
  class: "rounded-lg bg-gray-50 ring-1 ring-gray-200 p-8"
}
const _hoisted_6 = { class: "flex justify-center items-center" }
const _hoisted_7 = { class: "ml-3 text-sm font-medium text-gray-700" }
const _hoisted_8 = {
  key: 1,
  class: "rounded-lg bg-red-50 ring-1 ring-red-200 p-6"
}
const _hoisted_9 = { class: "flex items-start" }
const _hoisted_10 = { class: "ml-3 flex-1" }
const _hoisted_11 = { class: "text-sm font-medium text-red-800" }
const _hoisted_12 = { class: "mt-3" }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { class: "relative overflow-hidden p-4 flex flex-col bg-white border border-gray-200 rounded-xl before:absolute before:top-0 before:end-0 before:size-full before:bg-gradient-to-br before:from-blue-100 before:via-transparent before:blur-xl" }
const _hoisted_15 = { class: "relative z-10" }
const _hoisted_16 = { class: "flex justify-between items-center mb-1" }
const _hoisted_17 = { class: "text-4xl font-semibold text-gray-800" }
const _hoisted_18 = { class: "text-gray-500" }
const _hoisted_19 = { class: "relative overflow-hidden p-4 flex flex-col bg-white border border-gray-200 rounded-xl before:absolute before:top-0 before:end-0 before:size-full before:bg-gradient-to-br before:from-green-100 before:via-transparent before:blur-xl" }
const _hoisted_20 = { class: "relative z-10" }
const _hoisted_21 = { class: "flex justify-between items-center mb-1" }
const _hoisted_22 = { class: "text-4xl font-semibold text-gray-800" }
const _hoisted_23 = { class: "text-gray-500" }
const _hoisted_24 = {
  key: 0,
  class: "relative overflow-hidden p-4 flex flex-col bg-white border border-gray-200 rounded-xl before:absolute before:top-0 before:end-0 before:size-full before:bg-gradient-to-br before:from-purple-100 before:via-transparent before:blur-xl"
}
const _hoisted_25 = { class: "relative z-10" }
const _hoisted_26 = { class: "flex justify-between items-center mb-1" }
const _hoisted_27 = { class: "text-4xl font-semibold text-gray-800" }
const _hoisted_28 = { class: "text-gray-500" }
const _hoisted_29 = {
  key: 1,
  class: "relative overflow-hidden p-4 flex flex-col bg-white border border-gray-200 rounded-xl before:absolute before:top-0 before:end-0 before:size-full before:bg-gradient-to-br before:from-orange-100 before:via-transparent before:blur-xl"
}
const _hoisted_30 = { class: "relative z-10" }
const _hoisted_31 = { class: "flex justify-between items-center mb-1" }
const _hoisted_32 = { class: "text-4xl font-semibold text-gray-800" }
const _hoisted_33 = { class: "text-gray-500" }
const _hoisted_34 = {
  key: 0,
  class: "mt-6"
}
const _hoisted_35 = { class: "h-full relative flex flex-col bg-white border border-gray-200 rounded-xl" }
const _hoisted_36 = { class: "p-1.5 flex flex-col h-full" }
const _hoisted_37 = { class: "p-2.5" }
const _hoisted_38 = { class: "font-semibold text-xl md:text-2xl text-gray-800" }
const _hoisted_39 = { class: "mt-1 text-sm text-gray-600" }
const _hoisted_40 = {
  key: 1,
  class: "mt-6"
}
const _hoisted_41 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-4" }
const _hoisted_42 = { class: "relative flex flex-col bg-white border border-gray-200 rounded-xl" }
const _hoisted_43 = { class: "pt-2.5 px-4" }
const _hoisted_44 = { class: "font-semibold text-gray-800" }
const _hoisted_45 = { class: "p-1.5 flex flex-col flex-1" }
const _hoisted_46 = { class: "pt-1.5" }
const _hoisted_47 = { class: "p-2.5 rounded-lg bg-gray-100" }
const _hoisted_48 = {
  key: 0,
  class: "space-y-2"
}
const _hoisted_49 = { class: "flex shrink-0 justify-center items-center size-6 bg-white border border-gray-200 text-gray-800 text-xs font-medium uppercase rounded-lg" }
const _hoisted_50 = { class: "grow flex justify-between items-center gap-x-2" }
const _hoisted_51 = { class: "text-sm font-medium text-gray-600 truncate" }
const _hoisted_52 = {
  key: 1,
  class: "text-center py-4"
}
const _hoisted_53 = { class: "flex flex-col items-center" }
const _hoisted_54 = { class: "text-sm text-gray-500" }
const _hoisted_55 = {
  key: 0,
  class: "px-4 py-2 border-t border-gray-100"
}
const _hoisted_56 = { class: "h-full relative flex flex-col bg-white border border-gray-200 rounded-xl" }
const _hoisted_57 = { class: "pt-2.5 px-4" }
const _hoisted_58 = { class: "font-semibold text-gray-800" }
const _hoisted_59 = { class: "p-1.5 flex flex-col h-full" }
const _hoisted_60 = { class: "pt-1.5" }
const _hoisted_61 = { class: "p-2.5 rounded-lg bg-gray-100" }
const _hoisted_62 = {
  key: 0,
  class: "flex items-center gap-x-3"
}
const _hoisted_63 = { class: "flex-shrink-0" }
const _hoisted_64 = { class: "relative w-16 h-16 rounded-lg overflow-hidden bg-gray-200" }
const _hoisted_65 = ["src", "alt"]
const _hoisted_66 = { class: "flex-1 min-w-0" }
const _hoisted_67 = { class: "flex items-center justify-between gap-x-2" }
const _hoisted_68 = { class: "text-sm font-medium text-gray-600 truncate" }
const _hoisted_69 = { class: "flex-shrink-0 text-base font-bold text-gray-800" }
const _hoisted_70 = {
  key: 1,
  class: "text-center py-4"
}
const _hoisted_71 = { class: "flex flex-col items-center" }
const _hoisted_72 = { class: "text-sm text-gray-500" }
const _hoisted_73 = {
  key: 0,
  class: "fixed inset-0 z-50 flex items-center justify-center p-4"
}
const _hoisted_74 = { class: "relative bg-white rounded-xl shadow-xl w-full max-w-lg max-h-[80vh] flex flex-col" }
const _hoisted_75 = { class: "flex items-center justify-between px-6 py-4 border-b border-gray-200" }
const _hoisted_76 = { class: "text-base font-semibold text-gray-900" }
const _hoisted_77 = { class: "overflow-y-auto flex-1 px-6 py-4" }
const _hoisted_78 = {
  key: 0,
  class: "flex justify-center items-center py-8"
}
const _hoisted_79 = { class: "ml-3 text-sm text-gray-700" }
const _hoisted_80 = {
  key: 1,
  class: "flex flex-col items-center py-8 text-center"
}
const _hoisted_81 = { class: "text-sm text-gray-500" }
const _hoisted_82 = {
  key: 2,
  class: "space-y-2"
}
const _hoisted_83 = { class: "flex-shrink-0 w-6 text-center text-xs font-medium text-gray-400" }
const _hoisted_84 = { class: "flex-shrink-0 w-12 h-12 rounded-lg overflow-hidden bg-gray-200" }
const _hoisted_85 = ["src", "alt"]
const _hoisted_86 = { class: "flex-1 min-w-0 flex items-center justify-between gap-x-2" }
const _hoisted_87 = { class: "text-sm text-gray-700 truncate" }
const _hoisted_88 = { class: "flex-shrink-0 text-sm font-semibold text-gray-800 whitespace-nowrap" }
const _hoisted_89 = { class: "text-xs font-normal text-gray-400" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('gallery_settings.statistics.title')), 1),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('gallery_settings.statistics.tip_text')), 1)
        ]),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "animate-spin rounded-full h-8 w-8 border-b-2 border-royal-blue-600" }, null, -1)),
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('common.loading')), 1)
              ])
            ]))
          : (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                    _createElementVNode("svg", {
                      class: "h-5 w-5 text-red-400",
                      viewBox: "0 0 20 20",
                      fill: "currentColor",
                      "aria-hidden": "true"
                    }, [
                      _createElementVNode("path", {
                        "fill-rule": "evenodd",
                        d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z",
                        "clip-rule": "evenodd"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("h3", _hoisted_11, _toDisplayString(_ctx.$t('common.error_loading_data')), 1),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loadStats && _ctx.loadStats(...args))),
                        class: "inline-flex justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600 cursor-pointer"
                      }, _toDisplayString(_ctx.$t('common.retry')), 1)
                    ])
                  ])
                ])
              ]))
            : (_ctx.stats)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", {
                    class: _normalizeClass([
                    'grid gap-2 xl:gap-4',
                    _ctx.gallery.config.stats_enabled 
                        ? 'grid-cols-2 lg:grid-cols-2' 
                        : 'grid-cols-2'
                ])
                  }, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("h2", _hoisted_17, _toDisplayString(_ctx.stats.views_count || 0), 1),
                          _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"flex items-center -space-x-2\"><span class=\"flex shrink-0 justify-center items-center size-7 bg-white border border-gray-200 text-blue-500 shadow-xs rounded-full\"><svg class=\"shrink-0 size-4\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M15 12a3 3 0 11-6 0 3 3 0 016 0z\"></path><path d=\"M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z\"></path></svg></span></div>", 1))
                        ]),
                        _createElementVNode("h3", _hoisted_18, _toDisplayString(_ctx.$t('gallery_settings.statistics.views')), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("h2", _hoisted_22, _toDisplayString(_ctx.stats.downloads_count || 0), 1),
                          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "flex items-center -space-x-2" }, [
                            _createElementVNode("span", { class: "flex shrink-0 justify-center items-center size-7 bg-white border border-gray-200 text-green-500 shadow-xs rounded-full" }, [
                              _createElementVNode("svg", {
                                class: "shrink-0 size-4",
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "24",
                                height: "24",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }, [
                                _createElementVNode("path", { d: "M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10" })
                              ])
                            ])
                          ], -1))
                        ]),
                        _createElementVNode("h3", _hoisted_23, _toDisplayString(_ctx.$t('gallery_settings.statistics.downloads')), 1)
                      ])
                    ]),
                    (_ctx.gallery.config.stats_enabled)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("h2", _hoisted_27, _toDisplayString(_ctx.stats.files_downloads_count || 0), 1),
                              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "flex items-center -space-x-2" }, [
                                _createElementVNode("span", { class: "flex shrink-0 justify-center items-center size-7 bg-white border border-gray-200 text-purple-500 shadow-xs rounded-full" }, [
                                  _createElementVNode("svg", {
                                    class: "shrink-0 size-4",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round"
                                  }, [
                                    _createElementVNode("path", { d: "M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" })
                                  ])
                                ])
                              ], -1))
                            ]),
                            _createElementVNode("h3", _hoisted_28, _toDisplayString(_ctx.$t('gallery_settings.statistics.files_downloads')), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.gallery.config.stats_enabled)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("h2", _hoisted_32, _toDisplayString(_ctx.stats.shares_count || 0), 1),
                              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "flex items-center -space-x-2" }, [
                                _createElementVNode("span", { class: "flex shrink-0 justify-center items-center size-7 bg-white border border-gray-200 text-orange-500 shadow-xs rounded-full" }, [
                                  _createElementVNode("svg", {
                                    class: "shrink-0 size-4",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round"
                                  }, [
                                    _createElementVNode("path", { d: "M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.367 2.684 3 3 0 00-5.367-2.684z" })
                                  ])
                                ])
                              ], -1))
                            ]),
                            _createElementVNode("h3", _hoisted_33, _toDisplayString(_ctx.$t('gallery_settings.statistics.shares')), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 2),
                  (_ctx.gallery.config.stats_enabled)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("div", _hoisted_37, [
                              _createElementVNode("h4", _hoisted_38, _toDisplayString(_ctx.stats.last_download_date || _ctx.$t('gallery_settings.statistics.not_downloaded')), 1),
                              _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.$t('gallery_settings.statistics.last_download_date')), 1)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.gallery.config.stats_enabled)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("div", _hoisted_43, [
                              _createElementVNode("h2", _hoisted_44, _toDisplayString(_ctx.$t('gallery_settings.statistics.last_downloaded_files')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_45, [
                              _createElementVNode("div", _hoisted_46, [
                                _createElementVNode("div", _hoisted_47, [
                                  (_ctx.stats.last_downloaded_files && _ctx.stats.last_downloaded_files.length > 0)
                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_48, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stats.last_downloaded_files.slice(0, 1), (file, index) => {
                                          return (_openBlock(), _createElementBlock("li", {
                                            key: index,
                                            class: "flex items-center gap-x-2"
                                          }, [
                                            _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.getFileIcon(file)), 1),
                                            _createElementVNode("div", _hoisted_50, [
                                              _createElementVNode("span", _hoisted_51, _toDisplayString(file), 1)
                                            ])
                                          ]))
                                        }), 128))
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                        _createElementVNode("div", _hoisted_53, [
                                          _cache[12] || (_cache[12] = _createElementVNode("svg", {
                                            class: "w-8 h-8 text-gray-400 mb-2",
                                            fill: "none",
                                            stroke: "currentColor",
                                            viewBox: "0 0 24 24"
                                          }, [
                                            _createElementVNode("path", {
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round",
                                              "stroke-width": "2",
                                              d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                            })
                                          ], -1)),
                                          _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.$t('gallery_settings.statistics.no_downloaded_files')), 1)
                                        ])
                                      ]))
                                ])
                              ])
                            ]),
                            (_ctx.stats.last_downloaded_files && _ctx.stats.last_downloaded_files.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                  _createElementVNode("button", {
                                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openDownloadedPhotosModal && _ctx.openDownloadedPhotosModal(...args))),
                                    class: "w-full text-center text-xs text-royal-blue-600 hover:text-royal-blue-700 font-medium py-1 cursor-pointer"
                                  }, _toDisplayString(_ctx.$t('gallery_settings.statistics.view_all_downloaded')), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_56, [
                            _createElementVNode("div", _hoisted_57, [
                              _createElementVNode("h2", _hoisted_58, _toDisplayString(_ctx.$t('gallery_settings.statistics.most_downloaded_photo')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_59, [
                              _createElementVNode("div", _hoisted_60, [
                                _createElementVNode("div", _hoisted_61, [
                                  (_ctx.stats.most_downloaded_photo)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                        _createElementVNode("div", _hoisted_63, [
                                          _createElementVNode("div", _hoisted_64, [
                                            _createElementVNode("img", {
                                              src: _ctx.stats.most_downloaded_photo.preview_url,
                                              alt: _ctx.stats.most_downloaded_photo.filename,
                                              onError: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleImageError && _ctx.handleImageError(...args))),
                                              class: "w-full h-full object-cover"
                                            }, null, 40, _hoisted_65)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_66, [
                                          _createElementVNode("div", _hoisted_67, [
                                            _createElementVNode("span", _hoisted_68, _toDisplayString(_ctx.stats.most_downloaded_photo.filename), 1),
                                            _createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.stats.most_downloaded_photo.downloads_count), 1)
                                          ])
                                        ])
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                        _createElementVNode("div", _hoisted_71, [
                                          _cache[13] || (_cache[13] = _createElementVNode("svg", {
                                            class: "w-8 h-8 text-gray-400 mb-2",
                                            fill: "none",
                                            stroke: "currentColor",
                                            viewBox: "0 0 24 24"
                                          }, [
                                            _createElementVNode("path", {
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round",
                                              "stroke-width": "2",
                                              d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                                            })
                                          ], -1)),
                                          _createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.$t('gallery_settings.statistics.no_most_downloaded_photo')), 1)
                                        ])
                                      ]))
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.showDownloadedPhotosModal)
        ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
            _createElementVNode("div", {
              class: "absolute inset-0 bg-black/50",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeDownloadedPhotosModal && _ctx.closeDownloadedPhotosModal(...args)))
            }),
            _createElementVNode("div", _hoisted_74, [
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("h3", _hoisted_76, _toDisplayString(_ctx.$t('gallery_settings.statistics.downloaded_photos_title')), 1),
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeDownloadedPhotosModal && _ctx.closeDownloadedPhotosModal(...args))),
                  class: "text-gray-400 hover:text-gray-600 cursor-pointer"
                }, _cache[14] || (_cache[14] = [
                  _createElementVNode("svg", {
                    class: "w-5 h-5",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M6 18L18 6M6 6l12 12"
                    })
                  ], -1)
                ]))
              ]),
              _createElementVNode("div", _hoisted_77, [
                (_ctx.loadingDownloadedPhotos)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "animate-spin rounded-full h-8 w-8 border-b-2 border-royal-blue-600" }, null, -1)),
                      _createElementVNode("span", _hoisted_79, _toDisplayString(_ctx.$t('common.loading')), 1)
                    ]))
                  : (!_ctx.downloadedPhotos.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                        _cache[16] || (_cache[16] = _createElementVNode("svg", {
                          class: "w-10 h-10 text-gray-400 mb-2",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                          })
                        ], -1)),
                        _createElementVNode("span", _hoisted_81, _toDisplayString(_ctx.$t('gallery_settings.statistics.no_most_downloaded_photo')), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("ul", _hoisted_82, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.downloadedPhotos, (photo, index) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: index,
                            class: "flex items-center gap-x-3 p-2.5 rounded-lg hover:bg-gray-50"
                          }, [
                            _createElementVNode("span", _hoisted_83, _toDisplayString(index + 1), 1),
                            _createElementVNode("div", _hoisted_84, [
                              _createElementVNode("img", {
                                src: photo.preview_url,
                                alt: photo.filename,
                                onError: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleImageError && _ctx.handleImageError(...args))),
                                class: "w-full h-full object-cover"
                              }, null, 40, _hoisted_85)
                            ]),
                            _createElementVNode("div", _hoisted_86, [
                              _createElementVNode("span", _hoisted_87, _toDisplayString(photo.filename), 1),
                              _createElementVNode("span", _hoisted_88, [
                                _createTextVNode(_toDisplayString(photo.downloads_count) + " ", 1),
                                _createElementVNode("span", _hoisted_89, _toDisplayString(_ctx.$t('gallery_settings.statistics.downloaded_photos_downloads')), 1)
                              ])
                            ])
                          ]))
                        }), 128))
                      ]))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}